/* M&T — assistente de briefing para produtos de crochê/costura.
   Arquivo independente: NÃO toca no mt-studio.js. Carregado no <head> com defer,
   por isso registra o listener de submit ANTES do estúdio e decide quem atende. */
(function () {
  var cfgEl = document.getElementById('mtfluxo-cfg');
  var prodEl = document.getElementById('mtfluxo-produto');
  if (!cfgEl || !prodEl) return;
  var CFG, PROD;
  try { CFG = JSON.parse(cfgEl.textContent); PROD = JSON.parse(prodEl.textContent); } catch (e) { return; }
  var BF = CFG.briefing || {};
  var STEPS = BF.steps || [];
  if (!STEPS.length) return;

  var form = document.getElementById('mtpdp-form');
  if (!form) return;

  /* ---------- resolver o fluxo da variante escolhida ---------- */
  function norm(s) { return String(s == null ? '' : s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim(); }
  function variantAtual() {
    var el = document.getElementById('mtpdp-id');
    var id = el ? parseInt(el.value, 10) : 0;
    for (var i = 0; i < PROD.variantes.length; i++) { if (PROD.variantes[i].id === id) return PROD.variantes[i]; }
    return PROD.variantes[0];
  }
  function fluxoDe(v) {
    if (!v) return CFG['default'] || 'estudio';
    var regras = CFG.porOpcao || {};
    for (var nome in regras) {
      var idx = -1;
      for (var i = 0; i < PROD.opcoes.length; i++) { if (norm(PROD.opcoes[i]) === norm(nome)) { idx = i; break; } }
      if (idx < 0) return CFG.fallbackSeguro || 'briefing';
      var val = v.op[idx], mapa = regras[nome], achou = null;
      for (var k in mapa) { if (k !== '*' && norm(k) === norm(val)) { achou = mapa[k]; break; } }
      if (achou) return achou;
      if (mapa['*']) return mapa['*'];
    }
    return CFG['default'] || 'estudio';
  }
  function fluxo() { return fluxoDe(variantAtual()); }

  function escolhaDe(nomeOpcao) {
    var v = variantAtual(); if (!v) return null;
    for (var i = 0; i < PROD.opcoes.length; i++) { if (norm(PROD.opcoes[i]) === norm(nomeOpcao)) return v.op[i]; }
    return null;
  }
  function brl(c) { return (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
  function precoAtual() { var v = variantAtual(); return v ? v.preco : 0; }

  /* ---------- ícones dos temas (traço simples, linguagem M&T) ---------- */
  var IC = {
    floral: '<circle cx="12" cy="12" r="2.6"/><path d="M12 3.2a3 3 0 013 3c0 1.1-.7 2-1.6 2.5a4 4 0 00-2.8 0C9.7 8.2 9 7.3 9 6.2a3 3 0 013-3zM20.5 9.6a3 3 0 01-1.5 4c-1 .5-2.1.4-3-.2a4 4 0 00-1.4-2.4c.2-1 .9-1.9 1.9-2.3a3 3 0 014 .9zM17 20.4a3 3 0 01-4.2-.6c-.6-.9-.8-2-.5-3a4 4 0 002.3-1.6c1 .1 2 .7 2.5 1.6a3 3 0 01-.1 3.6zM7 20.4a3 3 0 01-.1-3.6c.5-.9 1.5-1.5 2.5-1.6a4 4 0 002.3 1.6c.3 1 .1 2.1-.5 3a3 3 0 01-4.2.6zM3.5 9.6a3 3 0 014-.9c1 .4 1.7 1.3 1.9 2.3a4 4 0 00-1.4 2.4c-.9.6-2 .7-3 .2a3 3 0 01-1.5-4z"/>',
    sol: '<circle cx="12" cy="12" r="4"/><path d="M12 2.6v2.2M12 19.2v2.2M2.6 12h2.2M19.2 12h2.2M5.3 5.3l1.6 1.6M17.1 17.1l1.6 1.6M18.7 5.3l-1.6 1.6M6.9 17.1l-1.6 1.6" stroke-linecap="round"/>',
    barquinho: '<path d="M12 3.4v8M12 3.4l6 5.2h-6M4.2 13.6h15.6l-2.4 5.2a3 3 0 01-2.7 1.7H9.3a3 3 0 01-2.7-1.7z"/>',
    arcoiris: '<path d="M3.6 18.6a8.4 8.4 0 0116.8 0M7 18.6a5 5 0 0110 0M10.2 18.6a1.8 1.8 0 013.6 0" stroke-linecap="round"/>',
    ursinho: '<circle cx="8" cy="6.4" r="2.4"/><circle cx="16" cy="6.4" r="2.4"/><circle cx="12" cy="13.4" r="6"/><circle cx="10" cy="12.4" r=".9" fill="currentColor" stroke="none"/><circle cx="14" cy="12.4" r=".9" fill="currentColor" stroke="none"/><path d="M10.8 16.2a2 2 0 002.4 0" stroke-linecap="round"/>',
    nuvem: '<path d="M6.8 18.4a4.2 4.2 0 01-.6-8.36 5.7 5.7 0 0111.1-1.24A4.7 4.7 0 0116.4 18.4z"/>',
    estrelas: '<path d="M12 3.6l2.2 4.5 5 .7-3.6 3.5.85 4.95L12 15l-4.45 2.2.85-4.95L4.8 8.8l5-.7z"/><path d="M18.6 17.4l.7 1.5 1.6.2-1.2 1.1.3 1.6-1.4-.75-1.4.75.3-1.6-1.2-1.1 1.6-.2z"/>',
    bichinhos: '<circle cx="7.4" cy="9" r="1.8"/><circle cx="16.6" cy="9" r="1.8"/><circle cx="5.2" cy="14.2" r="1.6"/><circle cx="18.8" cy="14.2" r="1.6"/><path d="M12 12.2c2.6 0 4.7 2.3 4.7 4.6 0 1.8-1.4 2.8-3 2.8-.7 0-1.2-.3-1.7-.3s-1 .3-1.7.3c-1.6 0-3-1-3-2.8 0-2.3 2.1-4.6 4.7-4.6z"/>',
    mar: '<path d="M2.8 16.2c1.6 0 1.6-1.5 3.2-1.5s1.6 1.5 3.2 1.5 1.6-1.5 3.2-1.5 1.6 1.5 3.2 1.5 1.6-1.5 3.2-1.5 1.6 1.5 3.2 1.5M2.8 20c1.6 0 1.6-1.5 3.2-1.5s1.6 1.5 3.2 1.5 1.6-1.5 3.2-1.5 1.6 1.5 3.2 1.5 1.6-1.5 3.2-1.5 1.6 1.5 3.2 1.5" stroke-linecap="round"/><circle cx="16.5" cy="7.5" r="3"/>',
    outro: '<path d="M12 4.2v15.6M4.2 12h15.6" stroke-linecap="round"/>'
  };
  function icone(id) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" aria-hidden="true">' + (IC[id] || IC.outro) + '</svg>';
  }
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg>';

  /* ---------- estado ---------- */
  var st = { i: 0, tema: null, nome: '', ideia: '', fotos: [], erro: '' };
  var root = null;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }
  function stepById(id) { for (var i = 0; i < STEPS.length; i++) { if (STEPS[i].id === id) return STEPS[i]; } return null; }
  function feito(i) {
    var s = STEPS[i]; if (!s) return false;
    if (s.id === 'tema') return !!st.tema;
    if (s.id === 'ideia') return !!(st.nome.trim() && st.ideia.trim());
    if (s.id === 'refs') return true;
    return false;
  }
  function podeIr(i) { for (var k = 0; k < i; k++) { if (STEPS[k].required && !feito(k)) return false; } return true; }

  /* ---------- montagem ---------- */
  function monta() {
    root = document.createElement('div');
    root.className = 'mtbf'; root.id = 'mtbf'; root.hidden = true;
    root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Criar sua capa bordada');
    root.setAttribute('data-lenis-prevent', '');
    root.innerHTML =
      '<header class="mtbf__top">' +
        '<button type="button" class="mtbf__pill" data-bf="voltar">&#8249; voltar</button>' +
        '<button type="button" class="mtbf__pill" data-bf="fechar">fechar &#10005;</button>' +
      '</header>' +
      '<div class="mtbf__body">' +
        '<aside class="mtbf__aside"><div class="mtbf__ph" id="mtbf-ph"></div><div class="mtbf__escolhas" id="mtbf-esc"></div></aside>' +
        '<div class="mtbf__col">' +
          '<div class="mtbf__panel" id="mtbf-panel"></div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(root);
    root.querySelector('[data-bf="fechar"]').addEventListener('click', fechar);
    root.querySelector('[data-bf="voltar"]').addEventListener('click', function () { if (st.i > 0) vai(st.i - 1); else fechar(); });
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape') fechar(); });
    root.addEventListener('wheel', function (e) {
      var col = root.querySelector('.mtbf__col');
      if (!col || col.contains(e.target)) return;
      col.scrollTop += e.deltaY;
    }, { passive: true });
  }

  function pintaAside() {
    var ph = document.getElementById('mtbf-ph');
    var img = document.querySelector('.mtpdp__main img') || document.querySelector('.mtpdp__frame img');
    ph.innerHTML = img ? '<img src="' + esc(img.currentSrc || img.src) + '" alt="">' : '';
    var esc_ = document.getElementById('mtbf-esc');
    var itens = (BF.resumoDaPDP || []).map(function (r) {
      var v = escolhaDe(r.opcao);
      return v ? '<span class="mtbf__esc">' + esc(r.label) + ' <b>' + esc(v.toLowerCase()) + '</b></span>' : '';
    }).join('');
    esc_.innerHTML = itens;
  }

  function pintaSteps() { /* painel unico: sem stepper (ref. Figma 611:12261) */ }

  var abertos = { nome: true, tema: true, ideia: true, refs: true };

  function grupo(n, id, titulo, preenchido, corpo, opcional) {
    var g = document.createElement('div');
    g.className = 'mtbf__grp' + (abertos[id] ? '' : ' is-closed');
    var h = document.createElement('div');
    h.className = 'mtbf__gh';
    h.innerHTML = '<span class="mtbf__gt">' + n + '. ' + esc(titulo) + '</span>' +
      '<span class="mtbf__ge">Editar</span>' +
      '<span class="mtbf__gc"' + (preenchido ? '' : ' hidden') + '>' + CHECK + '</span>' +
      '<svg class="mtbf__gv" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 15 12 9 18 15"/></svg>';
    h.addEventListener('click', function () {
      abertos[id] = !abertos[id];
      g.classList.toggle('is-closed', !abertos[id]);
    });
    var b = document.createElement('div');
    b.className = 'mtbf__gb';
    b.appendChild(corpo);
    g.appendChild(h); g.appendChild(b);
    if (opcional) { var o = document.createElement('span'); o.className = 'mtbf__opc'; o.textContent = 'opcional'; h.insertBefore(o, h.querySelector('.mtbf__ge')); }
    return g;
  }

  function corpoNome(s) {
    var cn = s.nome || { label: 'nome', max: 20 };
    var w = document.createElement('div');
    var i = document.createElement('input');
    i.type = 'text'; i.className = 'mtbf__input'; i.maxLength = cn.max || 20;
    i.placeholder = cn.ph || ''; i.value = st.nome;
    i.addEventListener('input', function () { st.nome = i.value; marca(); });
    w.appendChild(i);
    return w;
  }
  function corpoTema(s) {
    var w = document.createElement('div'); w.className = 'mtbf__chips';
    (s.options || []).forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mtbf__chip' + (st.tema === o.id ? ' is-on' : '');
      b.textContent = o.label;
      b.addEventListener('click', function () {
        st.tema = (st.tema === o.id) ? null : o.id;
        [].forEach.call(w.children, function (x) { x.classList.toggle('is-on', x === b && st.tema); });
        marca();
      });
      w.appendChild(b);
    });
    return w;
  }
  function corpoIdeia(s) {
    var w = document.createElement('div');
    var ta = document.createElement('textarea');
    ta.className = 'mtbf__ta'; ta.maxLength = s.max || 700;
    ta.placeholder = s.ph || ''; ta.value = st.ideia;
    var c = document.createElement('div'); c.className = 'mtbf__cnt';
    function up() { c.textContent = ta.value.length + '/' + ta.maxLength; c.className = 'mtbf__cnt' + (ta.value.length >= ta.maxLength ? ' is-max' : ''); }
    ta.addEventListener('input', function () { st.ideia = ta.value; up(); marca(); });
    w.appendChild(ta); w.appendChild(c); up();
    return w;
  }
  function corpoRefs(s) {
    var max = s.max || 5;
    var w = document.createElement('div');
    var gal = document.createElement('div'); gal.className = 'mtbf__files';
    st.fotos.forEach(function (f, i) {
      var d = document.createElement('div'); d.className = 'mtbf__file';
      d.innerHTML = '<img src="' + f.url + '" alt=""><button type="button" aria-label="remover">&#10005;</button>';
      d.querySelector('button').addEventListener('click', function () { URL.revokeObjectURL(f.url); st.fotos.splice(i, 1); pintaPainel(); });
      gal.appendChild(d);
    });
    if (st.fotos.length < max) {
      var add = document.createElement('button');
      add.type = 'button'; add.className = 'mtbf__add'; add.setAttribute('aria-label', 'adicionar imagem');
      add.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';
      var fi = document.createElement('input');
      fi.type = 'file'; fi.accept = 'image/*'; fi.multiple = true; fi.style.display = 'none';
      function put(lista) {
        st.erro = '';
        for (var i = 0; i < lista.length; i++) {
          if (st.fotos.length >= max) { st.erro = 'guardamos as ' + max + ' primeiras — o resto voce mostra na conversa.'; break; }
          var f = lista[i];
          if (!/^image\//.test(f.type)) { st.erro = 'so consigo receber imagens por aqui.'; continue; }
          if (f.size > 15 * 1024 * 1024) { st.erro = '"' + f.name + '" e muito pesada. tenta uma menor?'; continue; }
          st.fotos.push({ file: f, url: URL.createObjectURL(f) });
        }
        pintaPainel();
      }
      add.addEventListener('click', function () { fi.click(); });
      add.addEventListener('dragover', function (e) { e.preventDefault(); add.classList.add('is-over'); });
      add.addEventListener('dragleave', function () { add.classList.remove('is-over'); });
      add.addEventListener('drop', function (e) { e.preventDefault(); add.classList.remove('is-over'); put(e.dataTransfer.files); });
      fi.addEventListener('change', function () { put(fi.files); fi.value = ''; });
      gal.appendChild(add); w.appendChild(fi);
    }
    w.appendChild(gal);
    if (st.erro) { var er = document.createElement('p'); er.className = 'mtbf__erro'; er.textContent = st.erro; w.appendChild(er); }
    return w;
  }

  function prontoParaEnviar() { return !!(st.nome.trim() && st.tema && st.ideia.trim()); }
  function marca() {
    var p = document.getElementById('mtbf-panel');
    if (!p) return;
    var checks = p.querySelectorAll('.mtbf__gc');
    var ok = [!!st.nome.trim(), !!st.tema, !!st.ideia.trim(), st.fotos.length > 0];
    [].forEach.call(checks, function (c, i) { c.hidden = !ok[i]; });
    var cta = p.querySelector('.mtbf__cta');
    if (cta) cta.disabled = !prontoParaEnviar();
  }

  function pintaPainel() {
    var p = document.getElementById('mtbf-panel');
    p.innerHTML = '';
    var sNome = stepById('ideia') || {}, sTema = stepById('tema') || {}, sRefs = stepById('refs') || {};
    var h = document.createElement('h2'); h.className = 'mtbf__h';
    h.textContent = BF.titulo || 'vamos criar sua capa';
    p.appendChild(h);

    p.appendChild(grupo(1, 'nome', (sNome.nome && sNome.nome.label) || 'nome que vai bordado', !!st.nome.trim(), corpoNome(sNome)));
    p.appendChild(grupo(2, 'tema', 'qual o tema?', !!st.tema, corpoTema(sTema)));
    p.appendChild(grupo(3, 'ideia', 'descreva a sua ideia', !!st.ideia.trim(), corpoIdeia(sNome)));
    p.appendChild(grupo(4, 'refs', 'tem referências? anexe aqui', st.fotos.length > 0, corpoRefs(sRefs), true));

    if ((BF.posCompra || []).length) {
      var dp = document.createElement('div'); dp.className = 'mtbf__depois';
      dp.innerHTML = '<h4>o que acontece depois</h4><ol>' + BF.posCompra.map(function (e) {
        return '<li><span><b>' + esc(e.t) + '</b> — ' + esc(e.d) + '</span></li>';
      }).join('') + '</ol>';
      p.appendChild(dp);
    }

    var sub = document.createElement('div'); sub.className = 'mtbf__sub';
    sub.innerHTML = '<span>sub-total (1 item)</span><b>' + brl(precoAtual()) + '</b>';
    p.appendChild(sub);

    var cta = document.createElement('button');
    cta.type = 'button'; cta.className = 'mtbf__cta'; cta.textContent = 'continuar';
    cta.disabled = !prontoParaEnviar();
    cta.addEventListener('click', function () { enviar(cta); });
    p.appendChild(cta);

    var skip = document.createElement('button');
    skip.type = 'button'; skip.className = 'mtbf__skip'; skip.textContent = 'pular esse step';
    skip.addEventListener('click', function () { enviar(skip, true); });
    p.appendChild(skip);

    var nota = document.createElement('p'); nota.className = 'mtbf__nota';
    nota.textContent = 'nenhum ponto é costurado antes de você aprovar a arte.';
    p.appendChild(nota);
  }

  function vai(i) { pintaPainel(); var c = document.querySelector('.mtbf__col'); if (c) c.scrollTop = 0; }

  /* ---------- abrir / fechar ---------- */
  function abrir() {
    if (!root) monta();
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--mtsbw', (sbw > 0 ? sbw : 0) + 'px');
    if (window.__mtLenis && window.__mtLenis.stop) { try { window.__mtLenis.stop(); } catch (e) {} }
    document.documentElement.classList.add('mtbf-open');
    root.hidden = false; root.scrollTop = 0;
    pintaAside(); vai(st.i);
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-in'); }); });
  }
  function fechar() {
    if (!root) return;
    root.classList.remove('is-in');
    var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(function () {
      root.hidden = true;
      document.documentElement.classList.remove('mtbf-open');
      if (window.__mtLenis && window.__mtLenis.start) { try { window.__mtLenis.start(); } catch (e) {} }
    }, rm ? 0 : 400);
  }

  /* ---------- envio ---------- */
  function addonsSelecionados() {
    var out = [];
    document.querySelectorAll('.mtpdp__addoncb:checked').forEach(function (c) {
      var id = parseInt(c.getAttribute('data-variant-id'), 10);
      if (id) out.push({ id: id, quantity: 1 });
    });
    return out;
  }
  function enviar(btn, pulou) {
    var v = variantAtual(); if (!v) return;
    var temaS = stepById('tema'), lbl = st.tema;
    if (temaS) { (temaS.options || []).forEach(function (o) { if (o.id === st.tema) lbl = o.label; }); }
    btn.disabled = true; btn.textContent = (!pulou && st.fotos.length) ? 'enviando suas fotos…' : 'enviando…';

    var fd = new FormData();
    fd.append('id', String(v.id));
    fd.append('quantity', '1');
    if (pulou) {
      fd.append('properties[Briefing]', 'combinar na conversa');
    } else {
      fd.append('properties[Tema]', lbl || '');
      fd.append('properties[Nome bordado]', st.nome.trim());
      fd.append('properties[Sua ideia]', st.ideia.trim());
    }
    if (!pulou) { st.fotos.forEach(function (f, i) { fd.append('properties[Referência ' + (i + 1) + ']', f.file, f.file.name); }); }
    fd.append('properties[_briefing]', JSON.stringify({
      v: 1, tema: st.tema, nome: st.nome.trim(), ideia: st.ideia.trim(),
      refs: st.fotos.length, variante: v.id, opcoes: v.op
    }));

    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', body: fd, headers: { 'Accept': 'application/json' }
    }).then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'falha'); }); return r.json(); })
      .then(function () {
        var extras = addonsSelecionados();
        if (!extras.length) return null;
        return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: extras })
        });
      })
      .then(function () {
        fechar();
        st = { i: 0, tema: null, nome: '', ideia: '', fotos: [], erro: '' };
        setTimeout(function () { if (window.mtCart && window.mtCart.open) { window.mtCart.open(); } else { window.location = '/cart'; } }, 420);
      })
      .catch(function (err) {
        btn.disabled = false; btn.textContent = pulou ? 'pular esse step' : 'continuar';
        var p = document.getElementById('mtbf-panel');
        var e = p.querySelector('.mtbf__erro') || document.createElement('p');
        e.className = 'mtbf__erro'; e.textContent = 'não consegui enviar agora (' + err.message + '). tenta de novo?';
        p.appendChild(e);
      });
  }

  /* ---------- compra direta (fluxo "simples") ---------- */
  function compraDireta(btn) {
    var v = variantAtual(); if (!v) return;
    var itens = [{ id: v.id, quantity: 1 }].concat(addonsSelecionados());
    if (btn) btn.disabled = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: itens })
    }).then(function () {
      if (btn) btn.disabled = false;
      if (window.mtCart && window.mtCart.open) window.mtCart.open(); else window.location = '/cart';
    }).catch(function () { if (btn) btn.disabled = false; });
  }

  /* ---------- rótulo do CTA + faixa de processo ---------- */
  var faixa = null;
  function faixaProcesso() {
    if (!faixa) {
      faixa = document.createElement('div');
      faixa.className = 'mtbfx';
      faixa.innerHTML = '<span class="mtbfx__t">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M12 3.5l2.4 5 5.4.8-3.9 3.8.92 5.4L12 15.9l-4.82 2.6.92-5.4-3.9-3.8 5.4-.8z"/></svg>' +
        'feito à mão, junto com você</span>' +
        '<ul class="mtbfx__l">' + (BF.posCompra || []).map(function (e) { return '<li>' + esc(e.t) + '</li>'; }).join('') + '</ul>';
    }
    return faixa;
  }
  function atualizaCTA() {
    var f = fluxo();
    var b = document.getElementById('mtpdp-buytxt');
    var fl = document.getElementById('mtpdp-floattxt');
    if (f === 'briefing') {
      if (b) b.textContent = 'criar minha capa';
      if (fl) fl.textContent = 'criar minha capa';
      var alvo = document.getElementById('mtpdp-buy');
      var fx = faixaProcesso();
      if (alvo && alvo.parentNode && fx.parentNode !== alvo.parentNode) { alvo.parentNode.insertBefore(fx, alvo); }
      fx.hidden = false;
    } else {
      if (faixa) faixa.hidden = true;
      if (f === 'simples') {
        if (b) b.textContent = 'adicionar ao carrinho';
        if (fl) fl.textContent = 'adicionar ao carrinho';
      }
    }
  }

  /* ---------- interceptar o submit ANTES do estúdio ---------- */
  form.addEventListener('submit', function (e) {
    var f = fluxo();
    if (f === 'briefing') {
      e.preventDefault(); e.stopImmediatePropagation();
      abrir();
    } else if (f === 'simples') {
      e.preventDefault(); e.stopImmediatePropagation();
      compraDireta(document.getElementById('mtpdp-buy'));
    }
    /* fluxo "estudio": não faz nada — o mt-studio.js atende normalmente */
  }, true);

  form.addEventListener('change', function () { setTimeout(atualizaCTA, 0); });
  document.addEventListener('DOMContentLoaded', atualizaCTA);
  if (document.readyState !== 'loading') atualizaCTA();
  setTimeout(atualizaCTA, 400);
})();
